/** División macro (regiones oficiales) y zonas operativas (estado, AMG, zona costera, etc.). */
export type RegionCatalogLayer = 'region' | 'zone';

export interface RegionCatalogItem {
  slug: string;
  clv: string;
  name: string;
  gridPath: string;
  /** `region`: divisiones macro 10–24; `zone`: estado en catálogo, AMG, Tepic u otras zonas especiales. */
  type: RegionCatalogLayer;
  deprecated?: boolean;
}

export const REGION_CATALOG: RegionCatalogItem[] = [
  { slug: "norte", clv: "1NO", name: "Norte", gridPath: "/maps/zones/norte_grid_data.json", type: "region" },
  { slug: "altos_norte", clv: "2AN", name: "Altos Norte", gridPath: "/maps/zones/altos_norte_grid_data.json", type: "region" },
  { slug: "altos_sur", clv: "3AS", name: "Altos Sur", gridPath: "/maps/zones/altos_sur_grid_data.json", type: "region" },
  { slug: "cienaga", clv: "4CI", name: "Ciénega", gridPath: "/maps/zones/cienaga_grid_data.json", type: "region" },
  { slug: "sureste", clv: "5SE", name: "Sureste", gridPath: "/maps/zones/sureste_grid_data.json", type: "region" },
  { slug: "sur", clv: "6SU", name: "Sur", gridPath: "/maps/zones/sur_grid_data.json", type: "region" },
  { slug: "sierra_amula", clv: "7SA", name: "Sierra de Amula", gridPath: "/maps/zones/sierra_amula_grid_data.json", type: "region" },
  { slug: "costa_sur", clv: "8CS", name: "Costa Sur", gridPath: "/maps/zones/costa_sur_grid_data.json", type: "region" },
  { slug: "sierra_occidental", clv: "9SO", name: "Sierra Occidental", gridPath: "/maps/zones/sierra_occidental_grid_data.json", type: "region" },
  { slug: "costa_sierra", clv: "9CS", name: "Costa Sierra Occidental", gridPath: "/maps/zones/costa_sierra_grid_data.json", type: "region", deprecated: true },
  { slug: "lagunas", clv: "10LA", name: "Lagunas", gridPath: "/maps/zones/lagunas_grid_data.json", type: "region" },
  { slug: "valles", clv: "11VA", name: "Valles", gridPath: "/maps/zones/valles_grid_data.json", type: "region" },
  { slug: "centro", clv: "12CE", name: "Centro", gridPath: "/maps/zones/centro_grid_data.json", type: "region" },
  { slug: "costa_norte", clv: "13CN", name: "Costa Norte", gridPath: "/maps/zones/costa_norte_grid_data.json", type: "region" },
  { slug: "zona_costera", clv: "14ZC", name: "Zona Costera", gridPath: "/maps/zones/zona_costera_grid_data.json", type: "zone" },
  { slug: "lagunas_secas", clv: "15LS", name: "Lagunas Secas", gridPath: "/maps/zones/lagunas_secas_grid_data.json", type: "zone" },
  { slug: "jalisco", clv: "JAL", name: "Estado de Jalisco", gridPath: "/maps/states/jalisco_grid_data.json", type: "zone" },
  { slug: "amg", clv: "AMG", name: "Área Metropolitana de Guadalajara - AMG", gridPath: "/maps/zones/amg_grid_data.json", type: "zone" },
  { slug: "tepic", clv: "TEP", name: "Región prueba Tepic", gridPath: "/maps/zones/tepic_grid_data.json", type: "zone" },
];

